import { render, staticRenderFns } from "./Papeis.vue?vue&type=template&id=3a5bda2a&scoped=true"
import script from "./Papeis.vue?vue&type=script&lang=js"
export * from "./Papeis.vue?vue&type=script&lang=js"
import style0 from "./Papeis.vue?vue&type=style&index=0&id=3a5bda2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5bda2a",
  null
  
)

export default component.exports